import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {DesktopHeader} from 'components/DesktopHeader'
import {getSearchDesktopHeaderHeight} from 'modules/search/selectors'

const ContentSectionElement = styled.section<{
  searchDesktopHeaderHeight: number
}>`
  min-height: ${({searchDesktopHeaderHeight}) =>
    `calc(100vh - ${searchDesktopHeaderHeight}px)`};
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
`

interface PropsType {
  hasSearchForm: boolean
  hasFixedHeader?: boolean
  hasFilters?: boolean
  hasSearchProgressBar?: boolean
  customSearchBox?: React.ReactElement
  disableUserWidget?: boolean
  disableGetTheApp?: boolean
}

export const DesktopBaseLayout: React.FC<
  React.PropsWithChildren<PropsType>
> = ({
  children,
  hasSearchForm,
  hasFilters = false,
  hasFixedHeader,
  hasSearchProgressBar = false,
  customSearchBox,
  disableUserWidget = false,
  disableGetTheApp = false
}) => {
  const searchDesktopHeaderHeight =
    useSelector(getSearchDesktopHeaderHeight) ?? 0

  return (
    <>
      <DesktopHeader
        hasSearchForm={hasSearchForm}
        hasFilters={hasFilters}
        isFixed={hasFixedHeader}
        hasSearchProgressBar={hasSearchProgressBar}
        customSearchBox={customSearchBox}
        disableUserWidget={disableUserWidget}
        disableGetTheApp={disableGetTheApp}
      />

      <ContentSectionElement
        searchDesktopHeaderHeight={searchDesktopHeaderHeight}
      >
        {children}
      </ContentSectionElement>
    </>
  )
}
